module.exports = __webpack_public_path__ + "img/dan2.51f21b9a.png";